export default __webpack_public_path__ + "static/media/Reader's Gloves of the Waning Moon.b5301fd3.jpg";